/* eslint-disable @typescript-eslint/no-explicit-any */
import { io, Socket } from 'socket.io-client'
import { EnvironmentVariable } from '@/lib/http/constants'

class SocketService {
  private socket: Socket | null = null

  private readonly SOCKET_URL = EnvironmentVariable.localEnvConfig.API_URL

  connect(token: string, initEvent: string): void {
    if (this.socket?.connected) return

    const restaurantId = localStorage.getItem('restaurantId')
    if (!restaurantId) {
      console.error('Socket not connected: no restaurantId for this session')
      return
    }

    this.socket = io(this.SOCKET_URL, {
      auth: {
        token
      },
      query: {
        restaurantId
      },
      transports: ['websocket']
    })

    this.socket.on('connect', () => {
      this.socket?.emit(initEvent, 'hello')
      console.log('Socket connected:', this.socket?.id)
    })

    this.socket.on('disconnect', reason => {
      console.log('Socket disconnected:', reason)
    })

    this.socket.on('exception', error => {
      console.error('Socket error:', error)
    })
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect()
      this.socket = null
    }
  }

  emit(event: string, data: any): void {
    if (this.socket?.connected) {
      this.socket.emit(event, data)
    }
  }

  on(event: string, callback: (...args: any[]) => void): void {
    this.socket?.on(event, callback)
  }

  off(event: string, callback?: (...args: any[]) => void): void {
    if (callback) {
      this.socket?.off(event, callback)
    } else {
      this.socket?.off(event)
    }
  }

  isConnected(): boolean {
    return this.socket?.connected || false
  }
}

export const socketService = new SocketService()
